var typescript=Prism.util.clone(Prism.languages.typescript);Prism.languages.tsx=Prism.languages.extend("jsx",typescript);


//////////////////
// WEBPACK FOOTER
// ./node_modules/prismjs/components/prism-tsx.min.js
// module id = 1153
// module chunks = 0